import Vue from 'vue';
import Vuex from 'vuex';
import * as Cookies from 'js-cookie';
import global from '@/store/global.js';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
  },
  strict: debug,
  plugins: [createPersistedState(
    {
      key: 'tickets-state',
      getState: (key) => Cookies.getJSON(key),
      setState: (key, state) => {
        Cookies.set(key, state, {expires: 1});
      },
    },
  )],
});
